export default __webpack_public_path__ + "static/media/bibooFly.af4d92f9.png";